import Co_Pilot_Gemini from "../broucherPdf/Co_Pilot_Gemini.pdf";
import SIMACOLOR_fluids from "../broucherPdf/SIMACOLOR FLUIDS.pdf";
import STREAMLINE_4sp from "../broucherPdf/STREAMLINE 4SP -WHITE INK.pdf";
import usp_CO_PILOT_MAX_TURBO from "../broucherPdf/USP CO PILOT MAX TURBO.pdf";
import usp_CO2_Laser from "../broucherPdf/USP CO2 Laser.pdf";
import usp_COPILOt_128 from "../broucherPdf/USP COPILOT 128.pdf";
import usp_COPILOt_256 from "../broucherPdf/USP COPILOT 256.pdf";
import usp_COPILOt_128_256 from "../broucherPdf/CO PILOT 128-256.pdf";
import usp_COPILOt_400 from "../broucherPdf/USP COPILOT 400.pdf";
import usp_CoPilot_MAX_512i_TURBO from "../broucherPdf/USP CoPilot MAX 512i TURBO.pdf";
import usp_FIBER_LASER from "../broucherPdf/USP FIBER LASER.pdf";
import usp_Handheld_Fiber_Laser from "../broucherPdf/USP Handheld Fiber Laser.pdf";
import usp_JETSTREAM_II from "../broucherPdf/USP JETSTREAM II.pdf";
import usp_JETSTREAM_II_DUAL_HEAD from "../broucherPdf/JETSTREAM II DUAL PRINTHEAD SYSTEM.pdf";
import usp_STREAMLINE_PLUS from "../broucherPdf/USP STREAMLINE PLUS.pdf";
import usp_TTO_03J_05J from "../broucherPdf/USP TTO 03 J & 05 J.pdf";
import usp_TTO_D03S_D05S from "../broucherPdf/USP TTO_D03s and D05S.pdf";
import usp_TTO_Ribbons from "../broucherPdf/USP TTO Ribbons Spec-2024.pdf";
import usp_UVLaser from "../broucherPdf/USP UVLaser.pdf";
import usp_COPILOT_MAX_LT from "../broucherPdf/USP COPILOT MAX LT.pdf";

import usp_a2120 from "../broucherPdf/USP A-2120.pdf";
import usp_Laser_Blog from "../broucherPdf/USP_Laser_Blog.pdf";

const FilePdf = {
  Co_Pilot_Gemini: Co_Pilot_Gemini,
  SIMACOLOR_fluids: SIMACOLOR_fluids,
  STREAMLINE_4sp: STREAMLINE_4sp,
  usp_CO_PILOT_MAX_TURBO: usp_CO_PILOT_MAX_TURBO,
  usp_CO2_Laser: usp_CO2_Laser,
  usp_COPILOt_128: usp_COPILOt_128,
  usp_COPILOt_256: usp_COPILOt_256,
  usp_COPILOt_128_256: usp_COPILOt_128_256,
  usp_COPILOt_400: usp_COPILOt_400,
  usp_CoPilot_MAX_512i_TURBO: usp_CoPilot_MAX_512i_TURBO,
  usp_COPILOT_MAX_LT: usp_COPILOT_MAX_LT,
  usp_FIBER_LASER: usp_FIBER_LASER,
  usp_Handheld_Fiber_Laser: usp_Handheld_Fiber_Laser,
  usp_JETSTREAM_II: usp_JETSTREAM_II,
  usp_JETSTREAM_II_DUAL_HEAD: usp_JETSTREAM_II_DUAL_HEAD,
  usp_STREAMLINE_PLUS: usp_STREAMLINE_PLUS,
  usp_TTO_03J_05J: usp_TTO_03J_05J,
  usp_TTO_D03S_D05S: usp_TTO_D03S_D05S,
  usp_TTO_Ribbons: usp_TTO_Ribbons,
  usp_UVLaser: usp_UVLaser,
  usp_a2120: usp_a2120,
  usp_Laser_Blog: usp_Laser_Blog,
};

export default FilePdf;
